/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const estimateCost = /* GraphQL */ `query EstimateCost($input: String!) {
  estimateCost(input: $input) {
    items {
      name
      description
      cost
      items {
        name
        description
        cost
        items {
          name
          description
          cost
          items {
            name
            description
            cost
            items {
              name
              description
              cost
              showItems
              __typename
            }
            showItems
            __typename
          }
          showItems
          __typename
        }
        showItems
        __typename
      }
      showItems
      __typename
    }
    subTotal
    serviceFee
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EstimateCostQueryVariables,
  APITypes.EstimateCostQuery
>;
export const getLand = /* GraphQL */ `query GetLand($id: ID!) {
  getLand(id: $id) {
    id
    name
    description
    boundaryJSON {
      name
      key
      url
      __typename
    }
    images {
      name
      key
      url
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetLandQueryVariables, APITypes.GetLandQuery>;
export const listLands = /* GraphQL */ `query ListLands(
  $filter: ModelLandFilterInput
  $limit: Int
  $nextToken: String
) {
  listLands(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      boundaryJSON {
        name
        key
        url
        __typename
      }
      images {
        name
        key
        url
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListLandsQueryVariables, APITypes.ListLandsQuery>;
export const getHouse = /* GraphQL */ `query GetHouse($id: ID!) {
  getHouse(id: $id) {
    id
    name
    description
    modelJSON {
      name
      key
      url
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetHouseQueryVariables, APITypes.GetHouseQuery>;
export const listHouses = /* GraphQL */ `query ListHouses(
  $filter: ModelHouseFilterInput
  $limit: Int
  $nextToken: String
) {
  listHouses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      modelJSON {
        name
        key
        url
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHousesQueryVariables,
  APITypes.ListHousesQuery
>;
